import { FirmographicsFilters } from "@intentsify/types";

export const defaultFirmoFilters: FirmographicsFilters = {
  countries: [],
  employeeRanges: [],
  revenueRanges: [],
  usStates: [],
  naics2Codes: [],
  naics3Codes: [],
  naics4Codes: [],
  naics5Codes: [],
  naics6Codes: [],
  topics: [],
  keywords: [],
  installBaseProducts: [],
  businessEvents: [],
  includeOffice: false,
  intentsifyIndustry1: [],
  intentsifyIndustry2: [],
  intentsifyIndustry3: [],
  intentsifyIndustry4: [],
  intentsifyIndustry5: [],
  intentsifyIndustry6: [],
  codeAndIndustryRelation: "AND",
};
